import React from 'react';
import classNames from 'classnames';
import styles from './Product.module.scss';
import Badge, { BadgeType } from '../../Badge/Badge';
import Icon from '../../Icon/Icon';
import Image from '../../Image/Image';

export interface ProductListItemProps {
  imageSrc?: string;
  productName: string;
  stock?: number;
  productNumber?: string;
  status?: 'New' | 'In Process' | 'Completed';
  badgeType?: BadgeType;
}

const Product: React.FC<ProductListItemProps> = ({
  imageSrc,
  productName,
  stock,
  productNumber,
  status,
  badgeType = BadgeType.Neutral,
}) => {
  return (
    <div className={classNames(styles.root, 'px-16 py-12')}>
      <div className={styles.image}>
        <Image
          imageUrl={imageSrc || ''}
          alt={productName}
          fallbackComponent={
            <div className="flex justify-center items-center w-[40px] h-[40px]">
              <Icon name="package" width={25} height={25} className="text-disabled" />
            </div>
          }
        />
      </div>
      <div className="flex flex-col gap-y-6 flex-1">
        <span className="typo-text-14--bold text-full">{productName}</span>
        {stock && <span className="typo-text-12 text-faded">Lagerbestand: {stock}</span>}
      </div>
      {status && badgeType ? (
        <Badge showDot dotFilled type={badgeType} label={status} expanded />
      ) : (
        productName && <div className="typo-text-14 text-faded ml-auto">{productNumber}</div>
      )}
    </div>
  );
};

export default Product;
